import pclnExpt from '@pcln/experimentation'
import {
  PCLN_GRAPH_URL,
  GRAPH_CDN_PROD,
  GRAPH_CDN_QA,
  GRAPH_CDN_SETI,
  FLY_QL_URL,
  AIR_PRICE_GUIDE_URL,
  LOCAL_FLY_QL_URL,
} from './constants'
import { getStellateUrl } from '../../common/Stellate/helpers'
import { appendGqlOp } from '@mfs/common/utils/appendGqlOp'

const getEnv = () => (typeof window === 'undefined' ? '' : window.PCLN_BOOTSTRAP_DATA?.BOOTSTRAP_ENV)

const isProd = () => ['preprod', 'prod'].includes(getEnv())

const getGraphCdnURL = () => (isProd() ? GRAPH_CDN_PROD : GRAPH_CDN_QA)

const isEligibleAPI = (operationName) => {
  const setiName = GRAPH_CDN_SETI[operationName]
  if (setiName) {
    pclnExpt.fireImpression(setiName)
    return pclnExpt.isVariant(setiName)
  }
  return false
}

const getFlexDatesURL = ({ operationName, skipPclnGraph }) => {
  if (skipPclnGraph) {
    return AIR_PRICE_GUIDE_URL
  }
  return isEligibleAPI(operationName) ? getGraphCdnURL() : PCLN_GRAPH_URL
}

const getFlyQLURLClientSide = ({
  skipPclnGraph,
  useLocalFlyql,
  useStellate,
  pclnBootstrapData = {},
  streamingSSR,
}) => {
  let apiUrl = streamingSSR ? process.env.PCLN_GRAPH_CALL : PCLN_GRAPH_URL
  const { envUrl, BOOTSTRAP_ENV } = pclnBootstrapData
  if (useLocalFlyql) {
    return LOCAL_FLY_QL_URL
  }

  if (skipPclnGraph) {
    return FLY_QL_URL
  }
  return useStellate ? getStellateUrl({ envUrl, BOOTSTRAP_ENV, apiUrl }) : apiUrl
}

const getGraphURL = ({
  skipPclnGraph,
  useLocalFlyql,
  useStellate,
  pclnBootstrapData = {},
  streamingSSR,
  operationName,
}) => {
  let URL = getFlyQLURLClientSide({
    skipPclnGraph,
    useLocalFlyql,
    useStellate,
    pclnBootstrapData,
    streamingSSR,
  })

  if (operationName?.includes('airPriceGuide')) {
    URL = getFlexDatesURL({ operationName, skipPclnGraph })
  }

  return appendGqlOp({ endpoint: URL, gqlOp: operationName })
}

export { getGraphURL }
